// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6160fc75","588":"94fa80db"}[chunkId] + ".chunk.js";
};